var $ = jQuery;

function showTagData() {
	if ($("#VideoCommentForm_VideoCommentForm #Content .middleColumn").length) {
		var tagInfo = $("<span>&nbsp;</span>");
		tagInfo.addClass("tagTriggerDisplayContainer").insertBefore("#VideoCommentForm_VideoCommentForm #Content .middleColumn");
		var tagLink = $('<a href="#">(Tags)</a>');
		tagLink.appendTo(tagInfo);
		
		$("#tagDisplayContainer").initMainDialog({
			width:600
		});
		
		tagLink.click(function(e) {
			e.preventDefault();
			$("#tagDisplayContainer").dialog("open");
		});
	}
}

function go() {
	showTagData();
}

module.exports = go;